import { Component, ElementRef, ViewChild, OnInit } from '@angular/core';
import { IonicPage, NavParams, ActionSheet, ActionSheetController, Config, NavController, ToastController, PopoverController, AlertController } from 'ionic-angular';

import { PbZonenData, PbZonenActions } from '../../../providers/pbzonen-data';
import { ParkbewilligungenData } from '../parkbewilligungen-data';
import { ParkbewilligungenListPage } from '../parkbewilligungen-list';
import { PbzonenEditPage } from './pbzonen-edit/pbzonen-edit';
import { UserData } from '../../../providers/user-data';
import { MandantenData } from '../../../providers/mandanten-data';
import { CommonData } from '../../../providers/common-data';
import { Storage } from '@ionic/storage';
import { localeDe } from '../../../providers/aggridlocale.de'


import { PbZonenactionsPage } from '../pbzonenactions/pbzonenactions';
import { AgGridAngular } from 'ag-grid-angular';
import { AllModules, Module } from '@ag-grid-enterprise/all-modules';

/**
 * Generated class for the pbzonenPage page.
 *
 * See https://ionicframework.com/docs/components/#navigation for more info on
 * Ionic pages and navigation.
 */

@Component({
  selector: 'page-pbzonen',
  templateUrl: 'pbzonen.html',
})
export class PbzonenPage {
  @ViewChild('pbZonenGrid') agGrid: AgGridAngular;
  rowDataZonen:any;
  columnDefsZonen:any;
  gridOptionsZonen:any;
  searchQuery: string;
  bFilterActive: boolean;
  modules: Module[] = AllModules;

  constructor(
    public navCtrl: NavController
    , public navParams: NavParams
    , public zonenData: PbZonenData
    , public userData: UserData
    , public mData: MandantenData
    , public popoverCtrl: PopoverController
    , public toastCtrl: ToastController
    , public common: CommonData
    , public storage: Storage
    , private alertCtrl: AlertController
    , public pbData: ParkbewilligungenData

  ) {
    this.bFilterActive = false;
    if(this.userData.usergroup_id == 1){
      this.columnDefsZonen = [
        {
          headerName: 'Id', field: 'id' , filter: "agNumberColumnFilter", resizable: true , width:70 
        }

      ];      
      
    }
    else{
      this.columnDefsZonen = [];           
    }

    this.columnDefsZonen.push({headerName: 'Name', field: 'name', resizable: true, width:340 });
    this.columnDefsZonen.push({headerName: 'Öffentlich', field: 'sichtbar', resizable: true, width:100, valueGetter: this.sichtbarTextValueGetter.bind(this)   });
    
    this.columnDefsZonen.push(
      {headerName: "Grundstuecke (Gross-/Kleinschr. beachten)", field: "attributes.grundstuecknamen", resizable: true, width:400, filter: 'agTextColumnFilter', filterParams:{
        filterOptions:['contains', 'notContains'],
        textFormatter: function(r){
            if (r==null) return null;
  
            return r;
        },
        debounceMs:0,
        caseSensitive:true,
        suppressAndOrCondition:true
      }}
    );

    this.columnDefsZonen.push({headerName: 'Archiviert', field: 'archiviert', resizable: true, width:120 , valueGetter: this.archiviertTextValueGetter.bind(this)  });
    this.columnDefsZonen.push({headerName: 'Erzeugt', field: 'created', resizable: true, width:120,  type:['dateColumn', 'nonEditableColumn'], valueFormatter: this.dateFormatter.bind(this),  });
    
    this.gridOptionsZonen = {         
      localeTextFunc: (key: string, defaultValue: string) =>  localeDe[key] || defaultValue,       
      isExternalFilterPresent: this.isExternalFilterPresent.bind(this),
      doesExternalFilterPass: this.doesExternalFilterPass.bind(this),
      onGridReady: this.gridReady.bind(this),
      onFilterChanged: this.filterChanged.bind(this),
      
      floatingFilter: true,
      defaultColDef : {
        filter:true,
        sortable: true
      }
    }
    
    
    

  }
  dateFormatter(params) {
    
    return params.value;
    //-- wird aktuell nicht verwendet wegen sortierung
    /* 
    var dateAsString = params.value;
    console.log(params);
   
    var dateParts = dateAsString.split('-');
    return `${dateParts[0]} - ${dateParts[1]} - ${dateParts[2]}`;
    */
   
  }
  gridReady(event){
    
    //this.loadFilters();
  }
  filterChanged(event){
    var model = this.agGrid.gridOptions.api.getFilterModel();
    this.storage.set("pbzonefilter", model);        

    if(Object.keys(model).length !== 0){
      this.bFilterActive = true;
    }
    else{
      this.bFilterActive = false;
    }
  }
  ionViewWillEnter() {
    
    this.loaddata();
  }  

  async loadFilters(){
    let pbzonefilter = await this.storage.get("pbzonefilter");
    if(!pbzonefilter){
      pbzonefilter = {
        archiviert: {
          filterType: 'text',
          type: 'equals',
          filter: 'nein',
        }
      };
    }
    this.agGrid.api.setFilterModel(pbzonefilter);     
    var model = this.agGrid.api.getFilterModel();

  }

  ionViewDidEnter(){
    
  }
  
  archiviertTextValueGetter = function (params){
    return this.common.boolToText(params.data.archiviert);
  }
  sichtbarTextValueGetter = function (params){
    return this.common.boolToText(params.data.sichtbar);
  }

  mandateNameValueGetter = function (params) {
    if(this.mData){
      let m = this.mData.mandateby(params.data.mandate_id);
      if(m){
        return m.mandat;
      }
      else{
        return "";
      }  
    }
    else{
      return params.data.mandate_id;
    }    
  };

  loaddata(){
    this.zonenData.load().then(res => {      
      if(!this.rowDataZonen || this.rowDataZonen.lenght==0){
        this.rowDataZonen = this.zonenData.data;
      }
      else{
        //-- Neue Eitnräge hinzufügen ------
        var transactionobject = {add:[], update:[]};
        for(let i=0; i<this.zonenData.added_ids.length; i++){
          let newData = this.zonenData.data.find(x => x.id === this.zonenData.added_ids[i]);        
          if(newData){
            transactionobject.add.push(newData);
          }    
        }
        this.zonenData.added_ids.length = 0;
        //-- Einzeleinträge aktualisieren ---
        //let rowsSelection = this.agGrid.api.getSelectedRows();
        let selectedNodes = this.agGrid.api.getSelectedNodes();
        //console.log(rowsSelection.length);
        for(let i=0; i<selectedNodes.length; i++){
          let actnode = selectedNodes[i];
          let newData = this.zonenData.data.find(x => x.id === actnode.data.id);
          if(newData){
            actnode.setData(newData);
            this.agGrid.api.onFilterChanged();
          }    
        }
        this.gridOptionsZonen.api.updateRowData(transactionobject);

        this.agGrid.api.sizeColumnsToFit();
        
      }
      
    });        
  }



  showDetail(detail){
    this.navCtrl.push(PbzonenEditPage, {id:detail.id});
  }
  add(){
    this.navCtrl.push(PbzonenEditPage, {id:-1});    
  }

  isExternalFilterPresent() {
    return true;
  }

  doesExternalFilterPass(node) {
    return true;
  }  

  filterItems(ev: any) {
    this.searchGrid(ev);

  }     
  searchGrid(event){
    this.gridOptionsZonen.api.setQuickFilter(this.searchQuery);
  }  

  gridRowDblClicked(event: any){ 
    this.showDetail(event.data)
  }

  gridClearFilter(){

    this.agGrid.api.setFilterModel(null);
    this.agGrid.api.onFilterChanged();
  }    
  async archivieren(pbzone){
    let result:any = await this.zonenData.archivieren(pbzone.id);        
    if(result){
      let toast = this.toastCtrl.create({
        message: "Zone '" + result.name + "' archiviert",
        position: 'top',
        cssClass: 'toast-error',
        duration: 3000
      });
      pbzone.archiviert = 1;
      this.agGrid.api.refreshCells();
      this.agGrid.api.onFilterChanged(); 
      toast.present();   
    }
    else{
      let toast = this.toastCtrl.create({
        message: "Fehler beim Archivieren",
        position: 'top',
        cssClass: 'toast-error',
        duration: 5000
      });
      
      toast.present();   
    }
  }
  presentActions(event) {

    let rowsSelection = this.agGrid.api.getSelectedRows();

    if(rowsSelection.length <= 0){
      let toast = this.toastCtrl.create({
        message: "Es ist keine Zonen ausgewählt",
        position: 'top',
        cssClass: 'toast-error',
        duration: 3000
      });
      
      toast.present();   
      return;        
    }

    let popover = this.popoverCtrl.create(PbZonenactionsPage, {}, {cssClass: 'pbactions-popover'});    
    popover.onDidDismiss(async data => {
      const selectedNodes = this.agGrid.api.getSelectedNodes();
      const selectedData = selectedNodes.map( node => node.data );
      let pbzone = null;
      let result:any = null;
      if(selectedData && selectedData.length>0){
        pbzone = selectedData[0];
      }
      
      switch (this.zonenData.selectedZonenAction) {
        case PbZonenActions.ShowDetail:
            if(pbzone){
              this.showDetail(pbzone);
            }
            break;

        case PbZonenActions.ShowPb:
            if(pbzone){
              this.pbData.filterPbZone = pbzone.name;
              this.navCtrl.push(ParkbewilligungenListPage, {});
              //this.showDetail(pbkat);
            }
            break;
            

        case PbZonenActions.Duplicate:
          result = await this.zonenData.copy(pbzone.id);     
          //console.log(result);   
          if(result){
            let toast = this.toastCtrl.create({
              message: "Zone " + result.name + " erstellt",
              position: 'top',
              cssClass: 'toast-error',
              duration: 3000
            });
            //pbzone.archiviert = 1;
            //this.agGrid.api.refreshCells();
            //this.agGrid.api.onFilterChanged(); 
            toast.present();   
            this.loaddata();
          }
          else{
            let toast = this.toastCtrl.create({
              message: "Fehler beim Duplizieren",
              position: 'top',
              cssClass: 'toast-error',
              duration: 5000
            });
            
            toast.present();   
          }
          break;
      case PbZonenActions.Archive:
        let alert = this.alertCtrl.create({
          title: 'Zonen archivieren',
          message: 'Wollen Sie diese Zonen wirklich archivieren? Dadurch sind keine Bestellungen mehr möglich.',
          buttons: [
            {
              text: 'Nein',
              role: 'cancel',
              handler: () => {
                console.log('Cancel clicked');
              }
            },
            {
              text: 'Ja',
              handler: () => {
                this.archivieren(pbzone);


              }
            }          
          ]
        });
        alert.present();      
            break;

        default:
            break;
        }      
    }); 
    popover.present({
      ev: event
    });
  }  

  async excelExport(){
    var params = {
      allColumns: true,
      onlySelected: false,
      fileName: "zonen.xlsx",
      sheetName: "Zonen",
      exportMode: "xlsx"
    };    
    //console.log("START EXCEL EXPORT");
    //console.log(this.gridOptions);
    this.gridOptionsZonen.api.exportDataAsExcel(params);
  }  

}




// WEBPACK FOOTER //
// ./src/pages/parkbewilligungen/pbzonen/pbzonen.ts